/**
 * What a recently-played list does when you play something.
 *
 * Its own module, away from the hook, for the reason `arrival.ts` is: the rule
 * is the part worth testing and the React wiring is not, and a test that
 * reached the hook would drag the network client in with it.
 */

/**
 * How many to keep.
 *
 * A shelf, not a history. Twelve is the whole catalogue today, so the cap only
 * starts mattering as the catalogue grows - which is the right time for it to
 * start mattering.
 */
const KEEP = 12;

/**
 * The list with `gameId` at the front and no duplicate of it behind.
 *
 * A game you play twice is one entry, moved up. The alternative - a log -
 * answers a question nobody asked, and eight of the twelve slots would be last
 * night's Crazy Eights.
 */
export function promote(ids: readonly string[], gameId: string): string[] {
  return [gameId, ...ids.filter((id) => id !== gameId)].slice(0, KEEP);
}
